/**
 * Formats a date string in ISO8601 format to a human-friendly format
 * @param iso8601 {string} - A date string in ISO8601 format
 * @returns {string} - A human-friendly date string
 */
export function humanFriendlyFromISO8601(iso8601) {
  return new Date(iso8601).toLocaleString();
}